export const PRODUCTS = [
  {
    id: 'water-lily',
    name: 'Water Lily RO',
    brand: 'Water Lily',
    stages: 7,
    capacityLph: 15,
    tankCapacityLiters: 10,
    price: 8500,
    img: '/images/water-lily.jpg',
    rating: 4.5,
    warrantyMonths: 12,
    stock: 15,
    colorOptions: ['STD Green', 'STD Blue', 'Metallic Black', 'Metallic Cherry', 'Metallic Grey'],
    specs: {
      'TDS Reduction': '95-99%',
      Filters: ['Sediment', 'Pre-Carbon', 'RO Membrane', 'UV', 'UF', 'Post Carbon', 'Mineralizer'],
      Storage: '10 Liters Leak Proof Tank',
      Material: 'ABS Plastic',
      'LED Indicator': 'Yes',
    },
  },
  {
    id: 'aqua-mars',
    name: 'Aqua Mars',
    brand: 'Nile',
    stages: 6,
    capacityLph: 15,
    price: 6500,
    img: '/images/aqua-mars.jpg',
    rating: 4.4,
    warrantyMonths: 12,
    stock: 20,
    colorOptions: ['Stone Badge', 'Black', 'Premium Grey', 'Blue', 'Aqua Green'],
    specs: {
      'TDS Reduction': 'Up to 2000 ppm',
      Filters: ['Sediment', 'Activated Carbon', 'RO Membrane', 'Alkaline', 'TDS Controller'],
      Storage: '9 Liters Detachable Tank',
      Material: 'Food Grade ABS Plastic',
      'LED Indicator': 'Yes',
      Installation: 'Wall Mounting / Counter Top',
    },
  },
  {
    id: 'aqua-xl',
    name: 'Aqua XL',
    brand: 'Aqua XL',
    stages: 8,
    capacityLph: 15,
    tankCapacityLiters: 12,
    price: 10500,
    img: '/images/aqua-xl.jpg',
    rating: 4.7,
    warrantyMonths: 12,
    stock: 10,
    specs: {
      'TDS Reduction': '95-99%',
      Filters: ['Sediment', 'Carbon', 'RO Membrane', 'UV', 'UF', 'Mineral Cartridge', 'Copper-Zinc'],
      Storage: '12 Liters',
    },
  },
  {
    id: 'aqua-jade',
    name: 'Aqua Jade',
    brand: 'Aqua Jade',
    stages: 7,
    capacityLph: 15,
    tankCapacityLiters: 10,
    price: 7200,
    img: '/images/aqua-jade.jpg',
    rating: 4.6,
    warrantyMonths: 12,
    stock: 18,
    colorOptions: ['Aqua Green', 'Blue', 'Black', 'Grey', 'Comrade Blue'],
    specs: {
      'TDS Reduction': '95-99%',
      Filters: ['Sediment', 'Pre-Carbon', 'RO Membrane', 'UV', 'UF', 'Post Carbon', 'Mineralizer'],
      Storage: '10 Liters',
      Material: 'Food Grade ABS Plastic',
      'LED Indicator': 'Yes',
      Tank: 'Detachable & Lockable',
      Installation: 'Wall Mounting / Counter Top',
    },
  },
  {
    id: 'aqua-2050',
    name: 'Aqua 2090',
    brand: 'Aqua 2050',
    stages: 10,
    capacityLph: 15,
    tankCapacityLiters: 10,
    price: 9800,
    img: '/images/aqua-2050.jpg',
    rating: 4.7,
    warrantyMonths: 12,
    stock: 12,
    colorOptions: ['Deep Purple - 603', 'Premium Grey - 602', 'Blue - 201', 'Aqua Green - 202', 'Black - 203', 'Mirror Black - 601'],
    specs: {
      'TDS Reduction': '95-99%',
      Technology: 'RO + COPPER with ALKALINE',
      Filters: ['Sediment', 'Pre-Carbon', 'RO Membrane', 'Copper', 'Alkaline', 'UV', 'UF', 'Post Carbon', 'Mineralizer', 'TDS Controller'],
      Storage: '10 Liters',
      'Special Feature': 'NEXT Technology',
      Warranty: '10 Years Protection',
    },
  },
  {
    id: 'aqua-innovica',
    name: 'Aqua Innovica',
    brand: 'Aqua Innovica',
    stages: 7,
    capacityLph: 15,
    tankCapacityLiters: 11,
    price: 11500,
    img: '/images/aqua-innovica.jpg',
    rating: 4.8,
    warrantyMonths: 12,
    stock: 10,
    colorOptions: ['Candy White Aqua Green', 'Candy White Blue', 'Metallic Steel Grey', 'Metallic Energy Blue', 'Mirror Black'],
    specs: {
      'TDS Reduction': '95-99%',
      Filters: ['Sediment', 'Pre-Carbon', 'RO Membrane', 'UV', 'UF', 'Post Carbon'],
      Storage: '11 Liters',
      Material: 'Top & Side Spare ABS Plastic',
      Cabinet: 'Spring Cabinet with 4mm Thickness',
      Design: 'Luxurious Significance',
    },
  },
  {
    id: 'industrial-ro-25',
    name: 'Industrial RO Plant 25 LPH',
    brand: 'Generic',
    stages: 5,
    capacityLph: 25,
    tankCapacityLiters: 25,
    img: '/images/ro-25-lph.jpg',
    rating: 4.5,
    warrantyMonths: 12,
    stock: 5,
    specs: {
      'TDS Handling': 'Up to 2000 ppm',
      Power: '24V DC / 220V AC',
      Filters: ['Sediment', 'Carbon', 'RO Membrane (100 GPD x 1)', 'UV'],
      'Frame': 'SS Skid / FRP',
      'Storage Tank': '25 Liters',
    },
  },
  {
    id: 'industrial-ro-50',
    name: 'Industrial RO Plant 50 LPH',
    brand: 'Generic',
    stages: 5,
    capacityLph: 50,
    tankCapacityLiters: 50,
    img: '/images/ro-50-lph.jpg',
    rating: 4.6,
    warrantyMonths: 12,
    stock: 4,
    specs: {
      'TDS Handling': 'Up to 2000 ppm',
      Power: '220V AC',
      Filters: ['Sediment', 'Carbon', 'RO Membrane (100 GPD x 2/3)', 'Post Carbon'],
      'Automation': 'Fully Automatic',
      'Storage Tank': '50 Liters',
    },
  },
  {
    id: 'industrial-ro-100',
    name: 'Industrial RO Plant 100 LPH',
    brand: 'Generic',
    stages: 6,
    capacityLph: 100,
    tankCapacityLiters: 100,
    img: '/images/ro-100-lph.jpg',
    rating: 4.7,
    warrantyMonths: 12,
    stock: 3,
    specs: {
      'TDS Handling': 'Up to 3000 ppm',
      Power: '220V AC',
      Filters: ['Sand Filter', 'Carbon', 'Micron', 'RO Membranes (4021 x 1)', 'Anti-Scalant'],
      'Recovery Rate': '40-50%',
      'Storage Tank': '100 Liters',
    },
  },
  {
    id: 'industrial-ro-250',
    name: 'Industrial RO Plant 250 LPH',
    brand: 'Generic',
    stages: 7,
    capacityLph: 250,
    tankCapacityLiters: 150,
    img: '/images/ro-250-lph.jpg',
    rating: 4.8,
    warrantyMonths: 12,
    stock: 2,
    specs: {
      'TDS Handling': 'Up to 3000 ppm',
      Power: '220V AC',
      Filters: ['Multimedia Filter', 'Carbon', 'Micron', 'RO Membrane (4040 x 1)', 'UV'],
      'Pump': 'High Pressure 0.5/1 HP',
      'Storage Tank': '150 Liters',
    },
  },
  {
    id: 'industrial-ro-500',
    name: 'Industrial RO Plant 500 LPH',
    brand: 'Generic',
    stages: 5,
    capacityLph: 500,
    tankCapacityLiters: 500,
    img: '/images/ro-500-lph.jpg',
    rating: 4.8,
    warrantyMonths: 12,
    stock: 2,
    specs: {
      'TDS Handling': 'Up to 3000 ppm',
      Power: '220-440V AC',
      Filters: ['Sand Filter', 'Carbon Filter', 'Micron Cartridge', 'RO Membranes (4040)', 'Anti-Scalant'],
      'Recovery Rate': '50-70%',
      'Storage Tank': '500 Liters',
    },
  },
  {
    id: 'industrial-ro-1000',
    name: 'Industrial RO Plant 1000 LPH',
    brand: 'Generic',
    stages: 7,
    capacityLph: 1000,
    tankCapacityLiters: 1000,
    img: '/images/industrial-ro-500.jpg',
    rating: 4.9,
    warrantyMonths: 12,
    stock: 1,
    specs: {
      'TDS Handling': 'Up to 3500 ppm',
      Power: '440V AC (3 Phase)',
      Filters: ['Sand Filter', 'Carbon', 'Micron', 'RO Membranes (4040 x 4/5)', 'UV', 'Antiscalant'],
      'Operation': 'Fully Automatic',
      'Storage Tank': '1000 Liters',
    },
  },
  {
    id: 'industrial-ro-2000',
    name: 'Industrial RO Plant 2000 LPH',
    brand: 'Generic',
    stages: 8,
    capacityLph: 2000,
    tankCapacityLiters: 2000,
    img: '/images/industrial-ro-500.jpg',
    rating: 4.9,
    warrantyMonths: 12,
    stock: 1,
    specs: {
      'TDS Handling': 'Up to 3500 ppm',
      Power: '440V AC (3 Phase)',
      Filters: ['Multimedia', 'Carbon', 'Micron', 'RO Membranes (8040 x 2)', 'UV', 'CIP System'],
      'Frame': 'Stainless Steel',
      'Storage Tank': '2000 Liters',
    },
  },
  {
    id: 'aqua-grand-plus',
    name: 'Aqua Grand Plus',
    brand: 'Aqua Grand',
    stages: 10,
    capacityLph: 15,
    tankCapacityLiters: 12,
    price: 7500,
    img: '/images/aqua-grand-plus.jpg',
    rating: 4.3,
    warrantyMonths: 12,
    stock: 25,
    specs: {
      'TDS Reduction': '90-95%',
      Filters: ['Sediment', 'Carbon', 'RO', 'UV', 'UF', 'TDS Control', 'Mineral Enhancer'],
      Storage: '12 Liters',
    },
  },
];
